// 1
import { commitMutation } from "react-relay";
import graphql from "babel-plugin-relay/macro";
import environment from "../environment/index.js";

// 2
const mutation = graphql`
  mutation CreateMagazineMutation($magazine: newMagazine) {
    createMagazine(magazine: $magazine) {
      ... on Magazine {
        _id
        id
        name
        backgroundColor
        backgroundImage
        mainTemplateId
        subTemplateId
        portalId
        rows {
          content {
            description
            headerImage
            fileUrl
            videoThumbnail
            cardThumbnail
            headerOverlayContent
            heading
            subHeading
            graphData {
              attr1
              attr2
              attr3
              data {
                name
                val1
                val2
                val3
              }
            }
          }
          isShown
        }
        tags
        creator
        accountId
        createdAt
        updatedAt
      }
      ... on Response {
        hash
        message
        shared
        signedUrl
        status
        success
        token
        userId
      }
    }
  }
`;

export default (magazine, callback) => {
  // 4
  const variables = {
    magazine,
  };

  // 5
  commitMutation(environment, {
    mutation,
    variables,
    // 6
    onCompleted: response => {
      callback(response);
    },
    onError: err => callback(err),
    updater: store => {
      window.store = store;
    },
  });
}; // 3
